<template>
  <v-row dense>
    <v-col>
      <v-card :elevation="permitEdit ? '' : 0">
        <v-container fluid>
          <v-row dense v-if="isEditing">
            <v-col>
              <PrescriptionFormGuidance
                :attendance="attendance"
                :prescriptionId="prescriptionId"
                :prescriptionGuidance="prescriptionGuidance"
                :prescriptionInput="prescriptionInput"
                :refreshList="refreshList"
                :guidancePresets="guidancePresets"
                :prescriptionFrequencies="prescriptionFrequencies"
                :prescriptionPeriods="prescriptionPeriods"
                :prescriptionHowLongs="prescriptionHowLongs"
                :disabled="disabled"
              />
            </v-col>

            <v-col cols="auto" class="mt-3">
             <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small icon color="light-blue" :attrs="attrs" v-on="on" @click="isEditing = !isEditing">
                  <v-icon>eva-close-outline</v-icon>
              </v-btn>
              </template>
              <span> fechar janela</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row align="center" dense v-else>
            <v-col>
              <span class="font-weight-bold"> {{ index + 1 }} - </span>
              {{ prescriptionGuidance.description }}
            </v-col>

            <v-col cols="auto" v-if="permitEdit">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    :attrs="attrs"
                    v-on="on"
                    @click="isEditing = !isEditing"
                    :disabled="disabled"
                  >
                    <v-icon>eva-edit-2-outline</v-icon>
                  </v-btn>
                </template>

                <span>
                  Editar
                </span>
              </v-tooltip>
            </v-col>

            <v-col cols="auto" v-if="permitEdit">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    :attrs="attrs"
                    v-on="on"
                    @click="deletePrescriptionItem"
                    :disabled="disabled"
                  >
                    <v-icon>eva-trash-outline</v-icon>
                  </v-btn>
                </template>

                <span>
                  Excluir
                </span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import PrescriptionFormGuidance from "@/components/prescription/form/guidance.vue";

  import DELETE_PRESCRIPTION_GUIDANCE from "@/graphql/prescription/delete_prescription_guidance.gql";

  export default {
    name: "PrescriptionGuidance",
    props: {
      attendance: Object,
      prescriptionId: String,
      prescriptionGuidance: Object,
      prescriptionInput: Object,
      refreshList: Function,
      index: Number,
      permitEdit: {
        type: Boolean,
        default: true,
      },
      guidancePresets: {
        type: Array,
        default: () => [],
      },
      prescriptionFrequencies: {
        type: Array,
        default: () => [],
      },
      prescriptionPeriods: {
        type: Array,
        default: () => [],
      },
      prescriptionHowLongs: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      PrescriptionFormGuidance,
    },
    data() {
      return {
        isEditing: false,
      };
    },
    methods: {
      deletePrescriptionItem() {
        if (this.disabled) return;

        this.apolloMutate({
          mutation: DELETE_PRESCRIPTION_GUIDANCE,
          variables: {
            prescriptionGuidanceId: this.prescriptionGuidance.id,
          },
        }).then(() => {
          this.refreshList();
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
